import '../static/less/layout/header.less';
import '../static/images/SANDOS_logo_sm.png';
import '../static/images/MARCONFORT_logo_sm.png';
import '../static/images/PALMAIARESORTS_logo_sm.png';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import NewShoppingCartMobileHeader from './NewShoppingCartMobileHeader';
import { setUserCurrency, DEVICES, setPaymentCurrency } from '../actions/Booking';
import { setCallCenterCustomerCode } from '../actions/Session';
import { emptyShoppingCart } from '../actions/Cart';
import { getLangValue } from '../utils/Generic';

import AlertMessage from './AlertMessage';
import UserLogin from './user/UserLogin';
import DropdownList from './common/DropdownList';
import { logout } from '../actions/Loyalty';
import { store } from '../Store';
import withNavigate from '../withNavigate'; // Importa el HOC

const currencyNameFormat = (item) => item.code;

const langNameFormat = (item, lang, isTitle, isOpen, context) => {
  if (isTitle && !isOpen) {
    return item.code.toUpperCase();
  }
  return context.t(getLangValue(item, lang, 'name'));
};
class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openMobileMenu: false,
      openDropdownId: '', // "LanguageSelect" or "CurrencySelect" or "ForceMxnIpSelect"
    };

    const { call_center_dingus_codes } = this.props.chainData.booking_engine_configuration;

    if (this.props.callCenterCustomerCode == null) {
      // Si todavía no está seteado el state.session.callCenterCustomerCode en la sesión, lo seteamos con la primera opción
      // que venga en booking_engine_configuration.call_center_dingus_codes
      const selected_call_center_dingus_code = {
        name: call_center_dingus_codes[0],
        code: call_center_dingus_codes[0],
      };
      this.props.dispatch(setCallCenterCustomerCode(selected_call_center_dingus_code));
    }

    this.getHeaderLink = this.getHeaderLink.bind(this);
    this.onChangeCurrency = this.onChangeCurrency.bind(this);
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
    this.onChangeCallCenterCustomerCode = this.onChangeCallCenterCustomerCode.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.currencySelect = this.currencySelect.bind(this);
    this.languageSelect = this.languageSelect.bind(this);
    this.callCenterCustomerCodeSelect = this.callCenterCustomerCodeSelect.bind(this);
    this.renderMenuSelectors = this.renderMenuSelectors.bind(this);
    this.renderMobileMenu = this.renderMobileMenu.bind(this);
    this.userLogin = this.userLogin.bind(this);
    this.loyaltyUser = this.loyaltyUser.bind(this);
    this.setSelectedDropdown = this.setSelectedDropdown.bind(this);
  }

  setStartingCurrency() {
    if (this.props.hotel) {
      if (!this.props.paymentCurrency) {
        if (this.props.clientIpCountryCode != null) {
          if (this.props.isCallCenterUser === false) {
            const startingCurrencyCode = this.props.clientIpCountryCode === 'MX' ? 'MXN' : 'USD';
            const currency = this.props.currencies.find((element) => element.code === startingCurrencyCode);
            if (currency) {
              this.props.dispatch(setUserCurrency(currency));
              this.props.dispatch(setPaymentCurrency(currency.code));
            }
          } else {
            // Si es usuario call center
            const startingCurrencyCode = 'USD';
            const currency = this.props.currencies.find((element) => element.code === startingCurrencyCode);
            if (currency) {
              this.props.dispatch(setUserCurrency(currency));
              this.props.dispatch(setPaymentCurrency(currency.code));
            }
          }
        }
      }
    }
  }

  componentDidMount() {
    this.setStartingCurrency();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clientIpCountryCode !== this.props.clientIpCountryCode
      || prevProps.hotel !== this.props.hotel) {
      this.setStartingCurrency();
    }
  }

  getHeaderLink() {
    // For Call Center users, they go to the Engine Home page
    const { hotel, isCallCenterUser, chainData } = this.props;
    if (isCallCenterUser) {
      return '/';
    }

    // The booking_logo_hotel_link attribute is set in the chain model
    let hotel_home_url = '';
    if (hotel && hotel.booking_logo_hotel_link) {
      hotel_home_url = hotel.home_url; // it takes the URL for the language of the last availability
    }
    return hotel_home_url || chainData.web; // To the HomePage of the engine (www.sandos.com etc)
  }

  onChangeCurrency(currencyItem) {
    if (this.state.openMobileMenu) {
      this.toggleMobileMenu();
    }
    this.props.dispatch(setUserCurrency(currencyItem));
    this.props.dispatch(setPaymentCurrency(currencyItem.code));
  }

  onChangeLanguage(langItem) {
    if (this.state.openMobileMenu) {
      this.toggleMobileMenu();
    }
    this.props.dispatch(setLanguage(langItem.code));
  }

  onChangeCallCenterCustomerCode(callCenterCustomerCodeItem) {
    if (this.state.openMobileMenu) {
      this.toggleMobileMenu();
    }
    this.props.dispatch(setCallCenterCustomerCode(callCenterCustomerCodeItem));
    this.props.dispatch(emptyShoppingCart());
    this.props.navigate('/');
  }

  setSelectedDropdown(openDropdownId) {
    this.setState({ openDropdownId });
  }

  toggleMobileMenu() {
    const isOpen = !this.state.openMobileMenu;
    const update = {
      openMobileMenu: isOpen,
    };
    if (isOpen) {
      update.openDropdownId = 'close'; // force closing the open dropdown when closing the entire menu
    }
    this.setState(update);
  }

  currencySelect() {
    if (!this.props.filterCurrency) {
      // The currencies depend on the hotels, if there is no data the filter doesn't appear
      return null;
    }
    const { currencies, filterCurrency, lang } = this.props;
    // const updatedCurrencies = currencies;
    // El servicio de cambiodivisa.easy-pays.com no está funcionando para otras divisas distintas a USD y MXN
    // por eso mejor sólo dejaremos USD y MXN, además los hoteles de España que manejan EUR están desactivados
    const updatedCurrencies = currencies.filter((currency) => currency.code === 'MXN' || currency.code === 'USD');

    // TEMA VisualicacionTarifasEnDiversasCurrenciesParaCallCenter
    // Se pidió que los usuarios de call center puedan filtrar por varias currencies
    // para ver visualmente los montos. Anteriormente cuando el usuario de call center
    // filtraba por algún currency, también con eso se seteaba ese currency como
    // el payment currency.
    //let updatedCurrencies = currencies;
    //Pidieron nuevamente que funcionara como antes por lo que comentamos el siguiente if
    /*
    //Detectar si es directos call center, quitarle mxn (Eso habían pedido paro al final dijeron que
    ya no, por lo que se comenta)
    if (this.props.isCallCenterUser === true && this.props.callCenterCustomerCode.code === 'DIRECTOSCALLCENTER') {
      // Filtrar para eliminar el objeto con code "MXN"
      updatedCurrencies = currencies.filter((currency) => currency.code !== 'MXN');
    }
    */
    const title = this.context.t('Currency');
    const isClosed = Boolean(this.state.openDropdownId && this.state.openDropdownId !== 'CurrencySelect');
    return (
      <DropdownList selectId="CurrencySelect" items={updatedCurrencies} selectedItem={filterCurrency}
                    onChange={this.onChangeCurrency} nameFormat={currencyNameFormat} lang={lang} title={title}
                    onDropdownSelect={this.setSelectedDropdown} isClosed={isClosed} extraClass="currency"/>
    );
  }

  languageSelect() {
    const { lang } = this.props;
    const { languages } = this.props.chainData.booking_engine_configuration;
    // If chain only have one language, is not necessary to render the selector
    if (languages.length === 1) {
      return null;
    }

    const selectedLang = languages.find((langItem) => langItem.code === lang);
    const title = this.context.t('Language');
    const isClosed = Boolean(this.state.openDropdownId && this.state.openDropdownId !== 'LanguageSelect');
    return (
      <DropdownList selectId="LanguageSelect" items={languages} selectedItem={selectedLang}
                    onChange={this.onChangeLanguage} nameFormat={langNameFormat} lang={lang} title={title}
                    onDropdownSelect={this.setSelectedDropdown} isClosed={isClosed} extraClass="language"/>
    );
  }

  callCenterCustomerCodeSelect() {
    const { lang } = this.props;
    const { call_center_dingus_codes } = this.props.chainData.booking_engine_configuration;
    const options = call_center_dingus_codes.map((code) => ({
      name: code,
      code,
    }));
    const selectedCallCenterDingusCode = this.props.callCenterCustomerCode != null
      ? this.props.callCenterCustomerCode.code
      : null;
    const selected = {
      name: selectedCallCenterDingusCode,
      code: selectedCallCenterDingusCode,
    };
    // If it is a normal user it is not necessary to render the selector
    if (this.props.isCallCenterUser === false) {
      return null;
    }

    const title = this.context.t('Call Center Customer Code');
    const isClosed = Boolean(this.state.openDropdownId && this.state.openDropdownId !== 'CallCenterCustomerCodeSelect');
    return (
      <DropdownList selectId="CallCenterCustomerCodeSelect" items={options} selectedItem={selected}
                    onChange={this.onChangeCallCenterCustomerCode} lang={lang} title={title}
                    onDropdownSelect={this.setSelectedDropdown} isClosed={isClosed} extraClass="language"/>
    );
  }

  loyaltyUser() {
    const {
      loyaltyUser, lang, /*isCallCenterUser,*/ isLoyaltyUserLoggedIn, memberInfo,
    } = this.props;
    if (!isLoyaltyUserLoggedIn /*|| isCallCenterUser*/) {
      return null;
    }
    const options = [];
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;

    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'true') {
      return null;
    }

    if (agentCodeEnteredInBookingForm === '' /*&& this.props.isInBookingDetailsPage === false*/) {
      options.push({
        name: this.context.t('Close session'),
        code: 'close_session',
      });
    }
    const selected = {
      name: this.context.t('Hello {name}', { name: loyaltyUser ? loyaltyUser.first_name : memberInfo.accountHolder }),
      code: null,
    };
    const title = loyaltyUser ? `${loyaltyUser.first_name} ${loyaltyUser.surname}` : memberInfo.accountHolder;
    const isClosed = Boolean(this.state.openDropdownId && this.state.openDropdownId !== 'loyaltyUser');
    return <DropdownList
      onChange={() => this.props.dispatch(logout())}
      onDropdownSelect={this.setSelectedDropdown}
      selectId={'loyaltyUser'}
      isClosed={isClosed}
      selectedItem={selected}
      lang={lang}
      items={options}
      title={title}
      extraClass={'userLogout'}
    />;
  }

  userLogin() {
    if (this.state.isMobile && !this.state.openMobileMenu) {
      return null;
    }

    return (
              <UserLogin />
    );
  }

  renderMobileMenu() {
    const openClass = this.state.openMobileMenu ? 'mobile-open' : '';
    return (
      <div className={`Header__menu ${openClass}`}>
        <div className="toogle-btn" onClick={this.toggleMobileMenu}>
          <div className="bar bar-1" />
          <div className="bar bar-2" />
        </div>
        {this.renderMenuSelectors(openClass)}
      </div>
    );
  }

  renderMenuSelectors(extraClass) {
    return (
      <div className={`Header__selects ${extraClass}`}>
        <div className="close-mobile-menu" onClick={this.toggleMobileMenu}>
          {this.context.t('Menu')}
        </div>
        {this.userLogin()}
        {this.loyaltyUser()}
        {this.languageSelect()}
        {this.callCenterCustomerCodeSelect()}
        {this.currencySelect()}
      </div>
    );
  }

  render() {
    return (
      <header className="Header">
        {this.props.alertInfo ? <AlertMessage {...this.props.alertInfo} /> : null}
        <div className="Header-bar">
          <a className="Header__logo" href={this.getHeaderLink()}>
            <img src={`/img/${this.props.chain}_logo_sm.png`}/>
          </a>
          <div className="Header__title">
            {this.context.t('Book your next vacation!')}
          </div>
          {this.renderMobileMenu()}
        </div>
        {
          this.props.isMobile === true && this.props.shouldShowNewShoppingCartMobileHeader === true
          && <NewShoppingCartMobileHeader></NewShoppingCartMobileHeader>
        }
      </header>
    );
  }
}

Header.propTypes = {
  chain: PropTypes.string.isRequired,
  isCallCenterUser: PropTypes.bool.isRequired,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

Header.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  step: state.booking.step,
  alertInfo: state.booking.alertInfo,
  isMobile: state.booking.device === DEVICES.MOBILE,
  hotel: state.booking.hotel,
  shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
    || window.location.pathname === '/confirmation/'
    || window.location.pathname === '/thanks/'
    || window.location.pathname === '/booking-detail/'
  ),
  theme: state.session.theme,
  destination: state.bookingFormState.destination,
  currencies: state.booking.currencies,
  filterCurrency: state.booking.filterCurrency,
  chainData: state.session.chainData,
  callCenterCustomerCode: state.session.callCenterCustomerCode,
  loyaltyUser: state.loyalty.loggedUser,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  memberInfo: state.loyalty.memberInfo,
  isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
  || window.location.pathname.includes('/my-booking/')
  || window.location.pathname.includes('/booking-detail/'),
  clientIpCountryCode: state.booking.clientIpCountryCode,
  paymentCurrency: state.booking.paymentCurrency,
});

const ConnectedHeader = connect(mapStateToProps)(Header);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedHeader);
